import ".././App.css";
import React, { useEffect, useState } from "react";
import ButtonLeft from "../assets/images/icons/Button_left.svg";
import ButtonRight from "../assets/images/icons/Button_right.svg";

function TypeCarousel(props) {
  const [loadedIcons, setLoadedIcons] = useState({});
  const [data, setData] = useState([]);
  const [isMale, setSex] = useState(true);
  const [type, setType] = useState("");
  const [drawData, setDrawData] = useState([]);
  const [activeColor] = useState("01");
  const [activeType, setActiveType] = useState("01");
  const [activeElement, setActiveElement] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setType(props.type);
    setSex(props.sex);
    setData(props.data);
    var arrayTypes = [];
    props.data.forEach((item) => {
      var id = item.name[2] + item.name[3];
      if (!arrayTypes.find((x) => x.type == id)) {
        arrayTypes.push({ type: id, colors: [] });
      }
      var elem = arrayTypes.find((x) => x.type == id);
      if (elem != null) {
        var colorCode = item.name[5] + item.name[6];
        if (!elem.colors.includes(colorCode)) {
          elem.colors.push(colorCode);
        }
      }
    });
    setDrawData(arrayTypes);
    if (props.hair) {
      setActiveType(props.hair[9] + props.hair[10]);
    }
  }, [props.data]);

  function getSexCode(isMale) {
    if (isMale === "male") {
      return "m";
    } else if (isMale === "female") {
      return "f";
    }
  }

  function getTypeCode(type) {
    switch (type) {
      case "hair":
        return "h";
      case "facial_hair":
        return "f";
      case "glasses":
        return "g";
      default:
        return;
    }
  }

  const onChange = (event) => {
    var data = `${getTypeCode(type)}${getSexCode(isMale)}${event}c${activeColor}.png`;
    setActiveType(event);
    var elem = drawData.find((x) => x.type == event);
    if (elem != null) {
      setActiveElement(elem);
    }
    props.action(type, data);
  };

  const handlePrev = () => {
    setCurrentIndex(currentIndex === 0 ? drawData.length - 1 : currentIndex - 1);
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex === drawData.length - 1 ? 0 : currentIndex + 1);
  };

  const handleIconLoad = (iconId) => {
    setLoadedIcons((prevState) => ({ ...prevState, [iconId]: true }));
  };

  return (
    <div id="CharacterCreator">
      <div className="carousel__controls">
        <button onClick={handlePrev}>
          <img src={ButtonLeft} alt="" />
        </button>
        <button onClick={handleNext}>
          <img src={ButtonRight} alt="" />
        </button>
      </div>
      <div className="carousel">
        {drawData.map((icon, index) => (
          <div key={icon.type} className={`carousel__icon-container ${index >= currentIndex && index < currentIndex + 3 ? "" : "hide"}`}>
            {!loadedIcons[icon.type] && (
              <div
                className="placeholder-container"
                style={{ width: "100px", height: "100px", background: "grey", border: "1px solid black" }}
              ></div>
            )}

            <img
              className={`character-component ${loadedIcons[icon.type] ? "" : "hidden"}`}
              src={`https://storage.googleapis.com/anekdamian-site/preview/${type}/${isMale}/${getTypeCode(type)}${getSexCode(isMale)}${
                icon.type
              }c01.png`}
              onClick={() => {
                onChange(icon.type);
              }}
              onLoad={() => handleIconLoad(icon.type)}
              style={{ border: icon.type === activeType ? "2px solid #91ab87" : "none", cursor: "pointer", transition: "0.1s ease-in-out" }}
              alt="icon"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default TypeCarousel;
